export const API_HOST: string = process.env.REACT_APP_API_HOST || "";
export const ACCEPTABLE_RESPONSE =
    process.env.REACT_APP_ACCEPTABLE_RESPONSE || "JSON";

export const REQUEST_ACCEPT_HEADERS = {
    JSON: "application/json",
    HYDRA: "application/ld+json",
};
